/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/
(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail.variant;
    var container = event.target;
    var quickBtn = container.querySelector('.product__submit__quick');
    if (quickBtn) {
      if (variant && variant.available) {
        quickBtn.classList.remove('is-hidden');
      } else {
        quickBtn.classList.add('is-hidden');
      }
    }
  });

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  /*
    document.addEventListener('theme:scroll', e => { console.log(e); });
    document.addEventListener('theme:scroll:up', e => { console.log(e); });
    document.addEventListener('theme:scroll:down', e => { console.log(e); });
  */

  // Debounced resize listener to bundle changes that trigger document reflow
  /*
    document.addEventListener('theme:resize', e => { console.log(e); });
  */

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // -------------------------------------------------------
  // Manual filter button mode
  // When [data-manual-filter] is on the sidebar, suppress
  // theme.js auto-filtering and only trigger on Apply click.
  // -------------------------------------------------------

  // Reads the current form state and toggles .filter-apply--inactive
  // on the Apply button: inactive when no filters are selected.
  function updateApplyButtonState() {
    var btns = document.querySelectorAll('[data-apply-filters]');
    if (!btns.length) return;
    var form = document.querySelector('[data-sidebar-filter-form]');
    if (!form) return;

    // Any filter checkbox/radio ticked? Exclude no-js accordion checkboxes.
    var hasActive = !!form.querySelector(
      'input[type="checkbox"]:not(.no-js-checkbox):checked, input[type="radio"]:checked'
    );

    // Price range: value only exists when non-default; compare against placeholder.
    if (!hasActive) {
      var priceMin = form.querySelector('[data-field-price-min]');
      var priceMax = form.querySelector('[data-field-price-max]');
      if (priceMin && priceMax) {
        var minChanged = priceMin.value !== '' && priceMin.value !== priceMin.placeholder;
        var maxChanged = priceMax.value !== '' && priceMax.value !== priceMax.placeholder;
        if (minChanged || maxChanged) hasActive = true;
      }
    }

    btns.forEach(function (btn) {
      btn.classList.toggle('filter-apply--inactive', !hasActive);
    });
  }

  // Intercept form input events (capture = runs before theme.js listener).
  // Stops checkboxes/radios/price inputs from triggering instant filtering.
  document.addEventListener('input', function (e) {
    if (!document.querySelector('[data-manual-filter]')) return;
    if (window.innerWidth >= 768) return;  // ← ADD THIS
    if (!e.target.closest('[data-sidebar-filter-form]')) return;
    updateApplyButtonState();
    e.stopImmediatePropagation();
  }, true);

  // Intercept price range slider events (bubbles up from slider → form).
  // RangeSlider.onChange() already updated the input fields during drag,
  // so blocking here only stops the premature filtering call.
  document.addEventListener('theme:range:update', function (e) {
    if (!document.querySelector('[data-manual-filter]')) return;
    if (window.innerWidth >= 768) return;
    updateApplyButtonState();
    e.stopImmediatePropagation();
  }, true);

  // -------------------------------------------------------
  // Collection nav_links in manual-filter mode:
  // Clicking a sidebar navigation link (data-filter-update-url anchor)
  // records the target href instead of navigating immediately.
  // The Apply button then navigates to that href.
  // -------------------------------------------------------
  var pendingNavHref = null;

  document.addEventListener('click', function (e) {
    if (!document.querySelector('[data-manual-filter]')) return;
    if (window.innerWidth >= 768) return;  // ← ADD THIS
    var link = e.target.closest('[data-filter-update-url]');
    if (!link || link.tagName !== 'A') return;

    // Only intercept links inside the sidebar (not pagination, active-filter removes, etc.)
    var sidebar = link.closest('[data-collection-sidebar]');
    if (!sidebar) return;

    // Allow Clear Filters to work immediately
    if (link.classList.contains('sidebar__filters-clear')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var item = link.closest('.sidebar__item');
    var href = link.getAttribute('href');
    var isAlreadyPending = link.classList.contains('nav-link--pending');
    var isAlreadyActive  = item && item.classList.contains('sidebar__item--active');
    // "different pending" = another link was already queued, so clicking this active
    // item is a fresh selection, not a deselect.
    var hasDifferentPending = pendingNavHref !== null && pendingNavHref !== href;

    if (isAlreadyPending || (isAlreadyActive && !hasDifferentPending)) {
      // ── DESELECT ──────────────────────────────────────────────────────────
      // Same link clicked again, or the server-rendered active item clicked
      // while nothing else is queued → cancel pending navigation.
      pendingNavHref = null;

      sidebar.querySelectorAll('[data-filter-update-url].nav-link--pending').forEach(function (el) {
        el.classList.remove('nav-link--pending');
      });

      // Visually uncheck this item's box (overrides sidebar__item--active fill)
      if (item) item.classList.add('nav-link--deselecting');

      // Put Apply button back to inactive
      document.querySelectorAll('[data-apply-filters]').forEach(function (btn) {
        btn.classList.add('filter-apply--inactive');
      });

    } else {
      // ── SELECT ─────────────────────────────────────────────────────────────
      // Clear any leftover deselecting state from a previous deselect
      sidebar.querySelectorAll('.sidebar__item.nav-link--deselecting').forEach(function (el) {
        el.classList.remove('nav-link--deselecting');
      });

      pendingNavHref = href;

      sidebar.querySelectorAll('[data-filter-update-url].nav-link--pending').forEach(function (el) {
        el.classList.remove('nav-link--pending');
      });
      link.classList.add('nav-link--pending');

      document.querySelectorAll('[data-apply-filters]').forEach(function (btn) {
        btn.classList.remove('filter-apply--inactive');
      });
    }
  }, true);

  // Apply button click → if a nav link was pending, use AJAX navigation;
  // otherwise dispatch theme:form:filter to trigger normal AJAX filtering.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-apply-filters]');
    if (!btn) return;
    if (window.innerWidth >= 768) return;  // ← ADD THIS
    // Don't allow clicking when button is in inactive state
    if (btn.classList.contains('filter-apply--inactive')) return;
    
    if (pendingNavHref) {
      // Find the pending link and let theme.js drive the AJAX navigation.
      // We temporarily remove data-manual-filter so the custom.js nav-link
      // interceptor (capture phase) stands down, allowing theme.js's sidebar
      // click listener to call filtering(e, href) → getFilterResult().
      var sidebar = document.querySelector('[data-collection-sidebar]');
      var pendingLink = sidebar && sidebar.querySelector('[data-filter-update-url].nav-link--pending');

      if (pendingLink && sidebar) {
        sidebar.removeAttribute('data-manual-filter');
        pendingLink.click(); // theme.js handles AJAX + history push synchronously before fetch
        sidebar.setAttribute('data-manual-filter', '');
      } else {
        // Fallback if pending link is no longer in the DOM
        window.location.href = pendingNavHref;
      }
      pendingNavHref = null;
      return;
    }

    var sidebar = btn.closest('[data-collection-sidebar]');
    if (sidebar) {
      sidebar.dispatchEvent(new CustomEvent('theme:form:filter', { bubbles: true }));
    }
  });

  // Set initial button state on load, then re-check after every AJAX re-render.
  // getFilterResult() swaps sidebar.innerHTML in place, so childList fires.
  document.addEventListener('DOMContentLoaded', function () {
    updateApplyButtonState();

    var sidebar = document.querySelector('[data-collection-sidebar]');
    if (sidebar) {
      new MutationObserver(function () {
        updateApplyButtonState();
      }).observe(sidebar, { childList: true });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // -------------------------------------------------------
  // Product availability message (mobile only)
  // Shown below the size grid when show_availability_message
  // is enabled on the variant-selectors block.
  // -------------------------------------------------------
  (function () {
    var holidayCache = {};

    function getNthWeekday(year, month, weekday, n) {
      var d = new Date(year, month, 1), count = 0;
      while (true) {
        if (d.getDay() === weekday && ++count === n) return new Date(d);
        d.setDate(d.getDate() + 1);
      }
    }

    function getLastWeekday(year, month, weekday) {
      var d = new Date(year, month + 1, 0);
      while (d.getDay() !== weekday) d.setDate(d.getDate() - 1);
      return d;
    }

    function usHolidays(year) {
      if (holidayCache[year]) return holidayCache[year];
      var h = [];
      // Fixed-date holidays with weekend observance
      [[1,1],[6,19],[7,4],[11,11],[12,25]].forEach(function (md) {
        var d = new Date(year, md[0] - 1, md[1]);
        if (d.getDay() === 6) d.setDate(d.getDate() - 1);
        if (d.getDay() === 0) d.setDate(d.getDate() + 1);
        h.push(d.toDateString());
      });
      h.push(getNthWeekday(year, 0, 1, 3).toDateString());   // MLK Day
      h.push(getNthWeekday(year, 1, 1, 3).toDateString());   // Presidents Day
      h.push(getLastWeekday(year, 4, 1).toDateString());     // Memorial Day
      h.push(getNthWeekday(year, 8, 1, 1).toDateString());   // Labor Day
      h.push(getNthWeekday(year, 9, 1, 2).toDateString());   // Columbus Day
      h.push(getNthWeekday(year, 10, 4, 4).toDateString());  // Thanksgiving
      holidayCache[year] = h;
      return h;
    }

    function addWorkingDays(start, days) {
      var d = new Date(start), added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        if (dow === 0 || dow === 6) continue;
        if (usHolidays(d.getFullYear()).indexOf(d.toDateString()) !== -1) continue;
        added++;
      }
      return d;
    }

    function fmtDelivery(d) {
      var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
    }

    function fmtRestock(str) {
      if (!str) return '';
      var p = str.split('-');
      if (p.length !== 3) return str;
      var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
      var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    }

    function showAvailability(container, available, section) {
      var elStock   = container.querySelector('[data-availability-in-stock]');
      var elOos     = container.querySelector('[data-availability-oos]');
      var elDate    = container.querySelector('[data-delivery-date]');
      var elRestock = container.querySelector('[data-restock-date]');

      if (available) {
        elStock.style.display = 'flex';
        elOos.style.display   = 'none';
        if (elDate) elDate.textContent = fmtDelivery(addWorkingDays(new Date(), 4));
      } else {
        elStock.style.display = 'none';
        elOos.style.display   = 'block';
        if (elRestock) {
          var checked = section.querySelector('input[type="radio"][data-restock-date]:checked');
          elRestock.textContent = fmtRestock(checked ? checked.getAttribute('data-restock-date') : '') || 'Soon';
        }
      }
    }

    document.addEventListener('theme:variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;

      var section = e.target.closest && e.target.closest('[data-section-type="product"]');
      if (!section) return;

      var container = section.querySelector('[data-product-availability]');
      if (!container) return;

      // The checked radio carries inventory policy/quantity that the
      // variant JSON masks (continue-selling variants report available=true
      // even at 0 stock).
      var checked = section.querySelector('input[type="radio"][data-inventory-policy]:checked');
      var policy  = checked ? checked.getAttribute('data-inventory-policy') : '';
      var qty     = checked ? parseInt(checked.getAttribute('data-inventory-quantity'), 10) : 0;

      // Preorder = continue-selling AND no stock → "Back in Stock"
      // (matches current_is_preorder in the Liquid + the DOMContentLoaded handler).
      var isPreorder  = policy === 'continue' && qty <= 0;
      var isAvailable = variant.available === true;

      if (isPreorder) {
        container.removeAttribute('hidden');
        showAvailability(container, false, section);   // OOS / "Back in Stock"
      } else if (isAvailable) {
        container.removeAttribute('hidden');
        showAvailability(container, true, section);    // "In Stock & Ready to Ship"
      } else {
        container.setAttribute('hidden', '');          // hard OOS → wrapper hidden
      }
    });

    document.addEventListener('DOMContentLoaded', function () {

      document.querySelectorAll('[data-product-availability]').forEach(function (container) {
        var section = container.closest('[data-section-type="product"]');
        if (!section) return;
        var checked = section.querySelector('input[type="radio"][data-available]:checked');
        if (!checked) return;
        var isPreorder = checked.getAttribute('data-inventory-policy') === 'continue' &&
                         parseInt(checked.getAttribute('data-inventory-quantity'), 10) <= 0;
        showAvailability(container, isPreorder ? false : checked.getAttribute('data-available') === 'true', section);
      });
    });
  }());



  document.addEventListener('DOMContentLoaded', updates2025);
  function updates2025() {
    console.log("updates 2025");
    mobileNavAccordion();
    productSiblingLinks();

    // -------------------------------------------------------
    // Mobile nav accordion (level 1+ sub-menus)
    // -------------------------------------------------------
    function mobileNavAccordion() {

      // Toggle an accordion panel open or closed
      function setAccordion(trigger, open) {
        var contentId = trigger.getAttribute('aria-controls');
        var content = document.getElementById(contentId);
        if (!content) return;

        if (open) {
          trigger.setAttribute('aria-expanded', 'true');
          content.style.height = content.scrollHeight + 'px';
          content.addEventListener('transitionend', function onEnd() {
            // Set to auto so nested accordions expand properly
            if (trigger.getAttribute('aria-expanded') === 'true') {
              content.style.height = 'auto';
            }
            content.removeEventListener('transitionend', onEnd);
          });
        } else {
          // Collapse: pin current height then animate to 0
          content.style.height = content.scrollHeight + 'px';
          // Force reflow so transition fires
          content.offsetHeight; // eslint-disable-line no-unused-expressions
          trigger.setAttribute('aria-expanded', 'false');
          content.style.height = '0';
        }
      }

      // Close all open accordions within a container
      function closeAccordionsIn(container) {
        container.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]').forEach(function (t) {
          setAccordion(t, false);
        });
      }

      // Boot-height accordion: set display:flex BEFORE theme.js's slideDown measures height.
      // Using capture phase so this runs before theme.js's bubble-phase click handler.
      // slideDown checks "if display !== 'none' → return early", so it skips the animation
      // and just leaves the element visible. slideUp (closing) still works normally.
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-accordion-trigger]');
        if (!trigger || !trigger.closest('[data-collection-sidebar]')) return;
        var bodyId = trigger.getAttribute('aria-controls');
        var body = bodyId && document.getElementById(bodyId);
        if (!body || !body.classList.contains('sidebar__boot-height-grid')) return;
        if (window.getComputedStyle(body).display === 'none') {
          body.style.display = 'flex';
        }
      }, true);

      // Click delegation for accordion triggers
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-accordion-trigger]');
        if (!trigger) return;
        // Filter sidebar accordions are handled by theme.js — skip them
        if (trigger.closest('[data-collection-sidebar]')) return;

        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        // Close sibling accordions (one-open-at-a-time within the same list)
        var list = trigger.closest('.sliderow__links, .sliderule-grid, .sliderule__panel');
        if (list) {
          list.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]').forEach(function (sibling) {
            if (sibling !== trigger) setAccordion(sibling, false);
          });
        }

        setAccordion(trigger, !isExpanded);
      });

      // Reset all accordions when the mobile drawer closes
      document.addEventListener('theme:drawer:close', function () {
        document.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]').forEach(function (t) {
          var contentId = t.getAttribute('aria-controls');
          var content = document.getElementById(contentId);
          t.setAttribute('aria-expanded', 'false');
          if (content) content.style.height = '0';
        });
      });

      // Also reset when a sliderule slides back to level 0 (back-button pressed)
      document.addEventListener('theme:sliderule:close', function () {
        document.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]').forEach(function (t) {
          var contentId = t.getAttribute('aria-controls');
          var content = document.getElementById(contentId);
          t.setAttribute('aria-expanded', 'false');
          if (content) content.style.height = '0';
        });
      });

      // Sync aria-expanded for accordions that are open by default (accordion-is-open class)
      document.querySelectorAll('[data-accordion-trigger].accordion-is-open').forEach(function (trigger) {
        if (trigger.closest('[data-collection-sidebar]')) return;
        trigger.setAttribute('aria-expanded', 'true');
        var contentId = trigger.getAttribute('aria-controls');
        var content = document.getElementById(contentId);
        if (content) content.style.height = 'auto';
      });
    }

    function productSiblingLinks() {
      var fromLabel = (window.theme && theme.strings && theme.strings.from) || 'From';

      document.addEventListener('click', function (e) {
        var link = e.target.classList && e.target.classList.contains('siblings__link')
          ? e.target
          : (e.target.closest ? e.target.closest('.siblings__link') : null);
        if (!link) return;

        var info = link.closest('.product__grid__info');
        if (!info) return;

        // Title
        var siblingTitle = link.getAttribute('data-title-actual');
        var titleEl = info.querySelector('.product__grid__title');
        if (titleEl && siblingTitle) titleEl.textContent = siblingTitle;

        // Price
        var wrap = info.querySelector('.product__grid__price');
        var price = link.getAttribute('data-price');
        if (wrap && price) {
          var compare = link.getAttribute('data-compare-at') || '';
          var onSale = compare.trim() !== '';
          var varies = link.getAttribute('data-price-varies') === 'true';

          // Preserve the cutline span if the theme setting renders one
          var cutline = wrap.querySelector('.product__grid__cutline');
          var html = cutline ? cutline.outerHTML : '';

          html += '<span class="price' + (onSale ? ' on-sale' : '') + '">'
                + (varies ? fromLabel + ' ' : '') + price + '</span>';
          if (onSale) html += '<span class="compare-at">' + compare + '</span>';

          wrap.innerHTML = html;
        }

        // Point the card's title/price link at the selected sibling
        var href = link.getAttribute('href');
        if (href) {
          info.querySelectorAll('a[data-grid-link]').forEach(function (a) {
            if (!a.closest('.product__grid__sibs')) a.setAttribute('href', href);
          });
        }
      });
    }
  }
})();


(function() {
  var STYLE_ID = 'custom-redo-toggle-styles';
  var CUSTOM_CSS = `
    div[data-target="checkout-buttons-container"][data-target] {
      margin-top: 0px !important;
    }
    [data-target="checkout-buttons-container"] button[data-target="coverage-button"],
    [data-target="checkout-buttons-container"] button[data-target="non-coverage-button"] {
      width: 90% !important;
      max-width: 90% !important;
    }
    @media(max-width:749px){
      [data-target="checkout-buttons-container"] button[data-target="coverage-button"] p,
      [data-target="checkout-buttons-container"] button[data-target="non-coverage-button"] p {
        font-size: 12px;
      }
    }
  `;

  function injectStyles(host) {
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.getElementById(STYLE_ID)) return true; // already injected
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CUSTOM_CSS;
    host.shadowRoot.appendChild(style);
    return true;
  }

  function init() {
    var host = document.querySelector('redo-shopify-toggle');
    if (host) { injectStyles(host); return true; }
    return false;
  }

  if (init()) return;

  var observer = new MutationObserver(function(mutations, obs) {
    if (init()) obs.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() { observer.disconnect(); }, 30000);
})();

(function () {
  function repositionRebuyWidget() {
    var isMobile = window.innerWidth < 750;
    var rebuyDiv = document.querySelector('[data-rebuy-id="285187"]');
    var drawerBottom = document.querySelector('.drawer__bottom');
    var drawerBody = document.querySelector('.drawer__body');

    if (!rebuyDiv || !drawerBottom || !drawerBody) return;

    if (isMobile && rebuyDiv.closest('.drawer__bottom')) {
      // Move to end of .drawer__body so it scrolls with cart items
      drawerBody.appendChild(rebuyDiv);
    } else if (!isMobile && rebuyDiv.closest('.drawer__body')) {
      // Move back as first child of .drawer__bottom on desktop
      drawerBottom.insertBefore(rebuyDiv, drawerBottom.firstChild);
    }
  }

  // Debounced resize
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(repositionRebuyWidget, 150);
  });

  // Watch for drawer open + Rebuy widget being initialized
  var observer = new MutationObserver(function () {
    var rebuyInBottom = document.querySelector('.drawer--visible .drawer__bottom [data-rebuy-id="285187"]');
    if (rebuyInBottom) {
      repositionRebuyWidget();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', repositionRebuyWidget);
})();

(function () {
  if (!window.location.pathname.includes('/collections/')) return;

  var AVAIL_PARAM = 'filter.v.availability';
  var IN_STOCK = '1';
  var SESSION_KEY = 'cb_avail_user_cleared';

  var params = new URLSearchParams(window.location.search);
  var hasOtherFilters = [...params.keys()].some(function (k) {
    return k.startsWith('filter.') && k !== AVAIL_PARAM;
  });
  var hasAvailFilter = params.has(AVAIL_PARAM);
  var userCleared = sessionStorage.getItem(SESSION_KEY) === '1';

  // Detect if user navigated here by removing the In Stock pill (×)
  try {
    var ref = document.referrer;
    if (ref && new URL(ref).hostname === window.location.hostname) {
      var refParams = new URLSearchParams(new URL(ref).search);
      if (refParams.has(AVAIL_PARAM) && !hasAvailFilter && hasOtherFilters) {
        sessionStorage.setItem(SESSION_KEY, '1');
        userCleared = true;
      }
    }
  } catch (e) {}

  // On page load: auto-add In Stock if other filters active and user didn't clear it
  if (hasOtherFilters && !hasAvailFilter && !userCleared) {
    params.set(AVAIL_PARAM, IN_STOCK);
    window.location.replace(window.location.pathname + '?' + params.toString());
    return;
  }

  // Reset flag when back to no filters
  if (!hasOtherFilters && !hasAvailFilter) {
    sessionStorage.removeItem(SESSION_KEY);
  }

  // Track availability checkbox changes — save intent immediately
  // (desktop uses AJAX so there's no page reload to rely on)
  var userTouchedAvail = false;
  document.addEventListener('change', function (e) {
    if (e.target.name !== AVAIL_PARAM) return;
    userTouchedAvail = true;
    if (!e.target.checked) {
      sessionStorage.setItem(SESSION_KEY, '1');
    } else {
      sessionStorage.removeItem(SESSION_KEY);
    }
  });

  // Shared helper: check In Stock if conditions are met
  function maybeAutoCheckInStock(form) {
    var nonAvailChecked = form.querySelector(
      'input[name^="filter."]:not([name="' + AVAIL_PARAM + '"]):checked'
    );
    var availChecked = form.querySelector('input[name="' + AVAIL_PARAM + '"]:checked');
    if (nonAvailChecked && !availChecked && !userTouchedAvail && !sessionStorage.getItem(SESSION_KEY)) {
      var inStockInput = form.querySelector('input[name="' + AVAIL_PARAM + '"][value="' + IN_STOCK + '"]');
      if (inStockInput) inStockInput.checked = true;
    }
  }

  // DESKTOP (≥768): no Apply button — intercept before theme's input handler fires
  document.addEventListener('input', function (e) {
    if (window.innerWidth < 768) return;
    if (e.target.name === AVAIL_PARAM) return; // don't intercept availability itself
    var form = e.target.closest('form[data-sidebar-filter-form]');
    if (!form) return;
    maybeAutoCheckInStock(form);
  }, true); // capture phase — runs before theme.js

  // MOBILE (<768): intercept Apply button click before theme reads the form
  document.addEventListener('click', function (e) {
    if (window.innerWidth >= 768) return;
    var btn = e.target.closest('[data-apply-filters]');
    if (!btn) return;
    var form = btn.closest('form') || document.querySelector('form[data-sidebar-filter-form]');
    if (!form) return;
    maybeAutoCheckInStock(form);
  }, true); // capture phase

  // Clear everything when "Clear Filters" is clicked
  document.addEventListener('click', function (e) {
    var target = e.target.closest('a, button');
    if (target && target.textContent.trim().toLowerCase().includes('clear')) {
      sessionStorage.removeItem(SESSION_KEY);
      userTouchedAvail = false;
    }
  });
})();

// -------------------------------------------------------
// Keep filter sidebar open after AJAX filter updates (desktop only)
// -------------------------------------------------------
(function () {
  if (!window.location.pathname.includes('/collections/')) return;

  var userClosingFilters = false;

  // Flag when the user intentionally toggles the sidebar closed
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filters-toggle]')) {
      var sidebar = document.querySelector('[data-collection-sidebar]');
      // Only flag as "closing" if sidebar is currently open
      if (sidebar && sidebar.classList.contains('drawer--visible')) {
        userClosingFilters = true;
        setTimeout(function () { userClosingFilters = false; }, 600);
      }
    }
  }, true);

  function attachSidebarObserver() {
    var sidebar = document.querySelector('[data-collection-sidebar]');
    if (!sidebar) return;

    new MutationObserver(function (mutations) {
      if (userClosingFilters) return;
      if (window.innerWidth < 768) return; 

      mutations.forEach(function (m) {
        if (m.attributeName !== 'class') return;
        var hadVisible = m.oldValue && m.oldValue.includes('drawer--visible');
        var hasVisible = sidebar.classList.contains('drawer--visible');

        if (hadVisible && !hasVisible) {
          // AJAX stripped drawer--visible — restore it
          sidebar.classList.add('drawer--visible');
          var toggle = document.querySelector('[data-filters-toggle]');
          if (toggle) toggle.classList.add('drawer--visible');
        }
      });
    }).observe(sidebar, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class']
    });
  }

  document.addEventListener('DOMContentLoaded', attachSidebarObserver);
})();